import { useInfiniteQuery } from "hooks/useInfiniteQuery";
import { getSurmountAccountDocuments } from "../service";

export const useSurmountDocuments = () => {
  const { data, isLoading, fetchNextPage, isFetchingNextPage, refetch } =
    useInfiniteQuery({
      queryKey: ["surmountDocuments"],
      queryFn: async ({ pageParam = 1 }) => {
        const params = {
          page: pageParam,
          size: 10,
        };

        const response = await getSurmountAccountDocuments(params);
        return {
          data: response.data,
          currentPage: response.page,
          totalPages: response?.total_pages,
          totalCount: response.total_count,
        };
      },
      getNextPageParam: (lastPage) => {
        const currentPage = Number(lastPage.currentPage);
        const totalPages = Number(lastPage.totalPages);
        return currentPage < totalPages ? currentPage + 1 : undefined;
      },
    });

  const allDocuments = data?.pages?.flatMap((page) => page.data) || [];

  return {
    documents: allDocuments,
    isLoading,
    isFetchingNextPage,
    fetchNextPage,
    refetch,
  };
};
